// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-22-vw {
  width: 22vw;
}

.w-78-vw {
  width: 76vw;
}

.w-4-vw {
  width: 4vw;
}

.w-96-vw {
  width: 96vw;
}
`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/onboarding/src/component/AdminNavBar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb","sourcesContent":[".w-22-vw {\n  width: 22vw;\n}\n\n.w-78-vw {\n  width: 76vw;\n}\n\n.w-4-vw {\n  width: 4vw;\n}\n\n.w-96-vw {\n  width: 96vw;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
